import { BrowserRouter, Route, Switch } from "react-router-dom";
import React, { Component, Suspense, lazy } from 'react';
import './App.scss';
const NavBar = lazy(() => import('./components/NavBar'));
const Footer = lazy(() => import('./components/Footer'));
const Home = lazy(() => import('./pages/Home'));
const Curricula = lazy(() => import('./pages/Curricula'));
const StudyingSources = lazy(() => import('./pages/StudyingSources'));
const StudentActivities = lazy(() => import('./pages/StudentActivities'));
const Shop = lazy(() => import('./pages/Shop'));
const AboutSM = lazy(() => import('./pages/AboutSM'));
const Contact = lazy(() => import('./pages/Contact'));
const Contribute = lazy(() => import('./pages/Contribute'));

class App extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);

  }

  render() {
    return (
      <BrowserRouter>
        <div className="App">
        <Suspense fallback={<div>Loading...</div>}>
          <NavBar />
            <Switch>
              <Route exact path="/" component={props => <Home {...props} />} />
              <Route  path="/curricula" component={props => <Curricula {...props} />} />
              <Route  path="/studying_sources" component={props => <StudyingSources {...props} />} />
              <Route  path="/student_activities" component={props => <StudentActivities {...props} />} />
              <Route  path="/shop" component={props => <Shop {...props} />} />
              <Route  path="/about_sm" component={props => <AboutSM {...props} />} />
              <Route  path="/contact" component={props => <Contact {...props} />} />
              <Route  path="/contribute" component={props => <Contribute {...props} />} />
            </Switch>
          <Footer />
          </Suspense>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
